var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-steps',{attrs:{"active":_vm.active,"finish-status":"success"}},[_c('el-step',{attrs:{"title":"填写购券信息"}}),_c('el-step',{attrs:{"title":"支付"}}),_c('el-step',{attrs:{"description":"（使用默认文案无需审核）","title":_vm.text}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }